import React, { useState, useEffect } from 'react';
import InmobiliariasContainer from './InmobiliariasContainer';
import InmobiliariaFormModal from './InmobiliariaFormModal';
import { toast } from 'react-toastify';
import inmobiliariasService from '../services/inmobiliariasService';

const InmobiliariasTab = () => {
  // Estados para inmobiliarias
  const [inmobiliarias, setInmobiliarias] = useState([]);
  const [isFormModalOpen, setIsFormModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  // Cargar datos al montar el componente
  useEffect(() => {
    loadInmobiliarias();
  }, []);

  // Cargar todas las inmobiliarias
  const loadInmobiliarias = async () => {
    try {
      setLoading(true);
      const data = await inmobiliariasService.getInmobiliarias();
      setInmobiliarias(data);
    } catch (error) {
      toast.error('Error al cargar inmobiliarias: ' + (error.message || 'Error desconocido'));
    } finally {
      setLoading(false);
    }
  };

  // Handlers
  const handleOpenFormModal = () => {
    setIsFormModalOpen(true);
  };

  const handleCloseFormModal = () => {
    setIsFormModalOpen(false);
  };

  const handleAddInmobiliaria = async (newInmobiliaria) => {
    try {
      setLoading(true);

      // Validaciones adicionales
      if (!newInmobiliaria.name || newInmobiliaria.name.trim() === '') {
        toast.error('El nombre es requerido');
        return;
      }

      if (!newInmobiliaria.email_inmobiliaria || newInmobiliaria.email_inmobiliaria.trim() === '') {
        toast.error('El email es requerido');
        return;
      }

      if (!newInmobiliaria.ciudad_inmobiliaria || newInmobiliaria.ciudad_inmobiliaria.trim() === '') {
        toast.error('La ciudad es requerida');
        return;
      }

      const inmobiliariaData = {
        name: newInmobiliaria.name,
        email_inmobiliaria: newInmobiliaria.email_inmobiliaria,
        telefono: newInmobiliaria.telefono || '',
        number_home: newInmobiliaria.number_home || 0,
        ciudad_inmobiliaria: newInmobiliaria.ciudad_inmobiliaria,
        fecha: new Date().toISOString(),
        businness_price: newInmobiliaria.businness_price || 0,
        // Datos bancarios
        banco: newInmobiliaria.banco || '',
        numero_Cuenta: newInmobiliaria.numero_Cuenta || '',
        tipo_Cuenta: newInmobiliaria.tipo_Cuenta || '',
        nombre_Titular: newInmobiliaria.nombre_Titular || '',
        // Datos breve
        type_LLave: newInmobiliaria.type_LLave || '',
        number_LLave: newInmobiliaria.number_LLave || '',
        titular_Breve: newInmobiliaria.titular_Breve || ''
      };

      await inmobiliariasService.createInmobiliaria(inmobiliariaData);
      await loadInmobiliarias();
      toast.success('Inmobiliaria agregada exitosamente');
      handleCloseFormModal();
    } catch (error) {
      toast.error('Error al agregar inmobiliaria: ' + (error.message || 'Error desconocido'));
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateInmobiliaria = async (inmobiliariaId) => {
    const inmobiliaria = inmobiliarias.find(i => i.id === inmobiliariaId);
    if (inmobiliaria) {
      const newName = prompt('Nuevo nombre de la inmobiliaria:', inmobiliaria.name);
      if (newName && newName.trim() !== '') {
        try {
          setLoading(true);
          await inmobiliariasService.updateInmobiliaria(inmobiliariaId, {
            ...inmobiliaria,
            name: newName.trim()
          });
          await loadInmobiliarias();
          toast.success('Inmobiliaria actualizada exitosamente');
        } catch (error) {
          toast.error('Error al actualizar inmobiliaria: ' + (error.message || 'Error desconocido'));
        } finally {
          setLoading(false);
        }
      }
    }
  };

  const handleDeleteInmobiliaria = async (inmobiliariaId) => {
    if (window.confirm('¿Estás seguro de que deseas eliminar esta inmobiliaria?')) {
      try {
        setLoading(true);
        await inmobiliariasService.deleteInmobiliaria(inmobiliariaId);
        await loadInmobiliarias();
        toast.success('Inmobiliaria eliminada exitosamente');
      } catch (error) {
        toast.error('Error al eliminar inmobiliaria: ' + (error.message || 'Error desconocido'));
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <>
      {loading && (
        <div className="text-center py-4">
          <p className="text-gray-600">Cargando...</p>
        </div>
      )}

      {/* Contenedor de inmobiliarias */}
      <div style={{ height: 'calc(100vh - 250px)' }}>
        <InmobiliariasContainer
          inmobiliarias={inmobiliarias}
          onAddInmobiliaria={handleAddInmobiliaria}
          onUpdateInmobiliaria={handleUpdateInmobiliaria}
          onDeleteInmobiliaria={handleDeleteInmobiliaria}
          onOpenFormModal={handleOpenFormModal}
        />
      </div>

      {/* Modal de formulario de inmobiliaria */}
      <InmobiliariaFormModal
        isOpen={isFormModalOpen}
        onClose={handleCloseFormModal}
        onSubmit={handleAddInmobiliaria}
      />
    </>
  );
};

export default InmobiliariasTab;
